var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M8 5.833v5.334M8 16.5v10.667m8-21.334v13.334m0 5.333v2.667m8-21.334v1.334m0 5.333v14.667m-18.667-16h5.334V16.5H5.333v-5.333Zm8 8h5.334V24.5h-5.334v-5.333Zm8-12h5.334V12.5h-5.334V7.167Z","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }